// extracted by mini-css-extract-plugin
module.exports = {"rating":"a10a3f92e9--rating--SHXlJ","text":"a10a3f92e9--text--Syl8q"};